import styled from 'styled-components';

import { spacing, colors, transitions } from '../../../../styles/theme';

export const FormContainer = styled.div`
  margin-top: ${spacing('7')};
  display: flex;
  align-items: center;
  justify-content: center;

  form {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 480px;
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${spacing('6')};
  width: 100%;

  button {
    margin: 0;
  }
`;

export const ButtonBack = styled.button`
  padding: ${spacing('2')} ${spacing('4')};
  font-size: 16px;
  display: block;
  background: none;
  border: none;
  cursor: pointer;
  transition: ${transitions('fast')};

  &:hover {
    color: ${colors('accent.base')};
    transition: ${transitions('fast')};
  }
`;

